import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex, Input, Text } from 'theme-ui';
import { passwordLogin, resetAuth } from '../../../redux/feature/authSlice';
import { setLoginChildPageName } from '../../../redux/feature/loginCredSlice';
import { backendBaseUrl, heroViredWebUrl } from '../../../api/config';
import './loginWithEmail.scss';
import { fetchProgramType } from '../../../redux/feature/selfPacedSlice';

const LoginWithEmailPassword = () => {
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);
  const [passwordValue, setPasswordValue] = useState('');
  const [isEmpty, setIsEmpty] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const login = useSelector((state) => state.auth.passwordLogin);

  // console.log("password login details::::::::::::::::::", login);

  const dispatch = useDispatch();
  const handleGoBackToHome = () => {
    dispatch(setLoginChildPageName(null));
    dispatch(resetAuth());
  };

  const handleForgotPassword = () => {
    dispatch(setLoginChildPageName('forgotPassword'));
    dispatch(resetAuth());
  };

  const handlePasswordChange = (event) => {
    setPasswordValue(event.target.value);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const handleLogin = async () => {
    let usernameValue = usernameRef.current.value;
    let passwordValue = passwordRef.current.value;

    if (usernameValue == '' || passwordValue == '') {
      setIsEmpty(true);
    } else {
      // console.log("entered username and password",usernameValue, passwordValue);
      dispatch(
        passwordLogin({ userName: usernameValue, password: passwordValue })
      );
      setIsEmpty(false);
      const payload = {
        email: usernameValue.includes('@') ? usernameValue : '',
        phone: usernameValue.includes('@') ? '' : usernameValue
      };
    
      // ✅ Dispatch fetchProgramType with the payload
      dispatch(fetchProgramType(payload));
    }

    // if(response.status  == 200){
    //     let responseData = await response.json();
    //     console.log(responseData);
    //     let tokenValue = responseData.token;
    //     console.log(tokenValue);

    //     // let programUrl = `${backendApiUrl}?moodlewsrestformat=json&wstoken=${tokenValue}&wsfunction=block_programs_get_user_learningplans_details`;
    //     // let programResponse = await fetch(programUrl);
    //     // console.log(programResponse);
    //     // let programData = await programResponse.json();
    //     // console.log(programData);
    //     // let programValue = programData.program[0].lpid;
    //     // console.log(programValue);

    //     dispatch(setParams({token: tokenValue, program: programValue, isLoggedIn: true, userData: {username: usernameValue, userid: 2217}}));
    //     // navigate("/");
    // }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById('email-password-button').click();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <Box sx={{ fontSize: 3, width: '100%' }}>
      <Box
        mt={1}
        sx={{
          color: '#686868',
          fontSize: 3
        }}
        className='login-reset'
      >
        Login via OTP?
        <Text
          onClick={handleGoBackToHome}
          sx={{
            color: '#5095fc',
            cursor: 'pointer',
            fontWeight: 500,
            fontSize: '16px'
          }}
          className='login-reset'
        >
          {' '}
          Go back
        </Text>
      </Box>
      <Box
        style={{
          marginTop: '10px'
        }}
        className='login-label'
      >
        Email
      </Box>
      <Input
        ref={usernameRef}
        mt={1}
        type='text'
        placeholder='Enter email Id'
        className='login-input'
        required
      />
      <Box
        style={{
          marginTop: '24px'
        }}
        className='login-label'
      >
        Password
      </Box>
      <Flex mt={1} sx={{ position: 'relative' }}>
        <Input
          ref={passwordRef}
          type={isPasswordVisible ? 'text' : 'password'}
          placeholder='Enter password'
          className='login-input'
          value={passwordValue}
          onChange={handlePasswordChange}
          required
        />
        {passwordValue && (
          <Box
            sx={{
              position: 'absolute',
              right: '10px',
              top: '60%',
              transform: 'translateY(-50%)',
              cursor: 'pointer'
            }}
            onClick={togglePasswordVisibility}
          >
            {isPasswordVisible ? (
             <span
             class='material-symbols-outlined'
             style={{
               color: '#94a0b3',
               fontWeight: '550',
               fontSize: '20px'
             }}
           >
             visibility_off
           </span>
            ) : (
              <span
              class='material-symbols-outlined'
              style={{
                color: '#94a0b3',
                fontWeight: '550',
                fontSize: '20px'
              }}
            >
              visibility
            </span>
             
            )}
          </Box>
        )}
      </Flex>
      <a
        // target='_blank'
        // href={`${backendBaseUrl}/login/forgot_password.php`}
        className='login-link-button login-reset'
        style={{
          marginTop: '8px',
          color: '#5095fc'
        }}
        onClick={() => handleForgotPassword()}
      >
        Forgot password?
      </a>
      {login.error ? (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{ fontSize: '18px', marginRight: '4px' }}
            className='material-symbols-outlined'
          >
            info
          </Box>
          <Box className='error-text'>{login.error}</Box>
        </Flex>
      ) : (
        <></>
      )}
      {isEmpty && (
        <Flex
          mt={2}
          sx={{
            width: '100%',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '12px',
            lineHeight: '20px',
            color: '#E34935',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }}
        >
          <Box
            sx={{ fontSize: '18px', marginRight: '4px' }}
            className='material-symbols-outlined'
          >
            info
          </Box>
          <Box className='error-text'>
            {'Please enter a valid email address or password.'}
          </Box>
        </Flex>
      )}
      <button
        className='login-button'
        onClick={handleLogin}
        disabled={login.pending}
        id='email-password-button'
      >
        Login
      </button>
    </Box>
  );
};

export default LoginWithEmailPassword;
